import { postCreateSalesTax, putUpdateSalesTax } from "../../../../../api";
import { PrimaryButton, TextField } from "../../../../Libraries";
import { useLanguage, useToast } from "../../../../../context";
import { Collapse, SubHeader } from "../../../../common";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Switch } from "antd";

const CreateSalesTax = ({ from, item }) => {

    const { invokeToast } = useToast();
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [salesTax, setSalesTax] = useState({
        isInclusive: item?._id ? item.isInclusive : true,
        rate: item?.rate || '',
        name: item?.name || '',
    });

    const validateSalesTax = () => {
        let obj = {};

        if (!salesTax['name']) obj = { ...obj, name: 'Name is invalid' };
        if (!salesTax['rate']) obj = { ...obj, rate: 'Rate is invalid' };

        return obj;
    };

    const onSave = async (event) => {
        window.scrollTo({ top: 0 });
        event.stopPropagation();
        event.preventDefault();

        try {

            if (Object.values(validateSalesTax()).length) {
                setErrors(validateSalesTax());
                return;
            };

            setLoading(true);

            const { isInclusive, name, rate } = salesTax;

            let params = { isInclusive, name, rate };

            from == 'edit' ? await putUpdateSalesTax(item._id, params) : await postCreateSalesTax(params);

            invokeToast({ message: `Sales Tax ${from == 'edit' ? 'updated' : 'created'} successfully!`, type: 'success' });

            navigate('/sales-tax');
        } catch (err) {
            invokeToast({ message: err, type: 'danger' });
        } finally {
            setLoading(false);
        }
    };

    const onChange = (key, value) => {
        let error = { ...errors };
        setSalesTax(prev => {
            let all = { ...prev };
            all[key] = value;
            if (error[key]) error[key] = '';
            return all;
        });
        if (errors[key]) setErrors(error);
    };

    const handleBack = () => navigate(-1);
    const onCancel = () => navigate(-1);

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        title: from == 'edit' ? 'edit_sale_tax' : 'new_sales_tax',
                        subTitle: from == 'edit' ? '' : 'create_new_sales_tax',
                        flip: true,
                        actions: [{
                            className: 'btn btn-added color',
                            title: 'back_to_sales_tax',
                            action: handleBack,
                            icon: 'arrow-left',
                        }]
                    }}
                />

                <form type="submit" onSubmit={onSave} >
                    <div className="card">
                        <div className="card-body add-product pb-0">
                            <div
                                className="accordion-card-one accordion"
                                id="accordionExample"
                            >
                                <div className="accordion-item">
                                    <Collapse
                                        data={{
                                            title: I18n.sales_tax_information,
                                            target: 'collapseOne',
                                            id: 'headingOne',
                                            icon: 'info',
                                        }} >
                                    </Collapse>

                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse show"
                                        aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body">
                                            <div className="row">
                                                <TextField
                                                    onChange={(value) => onChange('name', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    placeholder="enter_sales_tax_name"
                                                    innerContClass='mb-3 add-product'
                                                    label={'sales_tax_name'}
                                                    value={salesTax.name}
                                                    error={errors?.name}
                                                    type={"text"}
                                                />

                                                <TextField
                                                    placeholder="enter_sales_tax_rate_in_percentage"
                                                    onChange={(value) => onChange('rate', value)}
                                                    containerClass='col-lg-4 col-sm-6 col-12'
                                                    innerContClass='mb-3 add-product'
                                                    label={'sales_tax_rate'}
                                                    value={salesTax.rate}
                                                    error={errors?.rate}
                                                    type={"text"}
                                                    onlyNumber
                                                />

                                                <div className='col-lg-4 col-sm-6 col-12'>
                                                    {<label className="form-label">{I18n['inclusive']}</label>}
                                                    <div className="mt-2 add-product">
                                                        <Switch
                                                            value={salesTax.isInclusive}
                                                            onChange={(value) => onChange('isInclusive', value)}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="btn-addproduct mb-4">
                            <PrimaryButton
                                className='btn btn-cancel me-2'
                                onClick={onCancel}
                                title={'cancel'}
                                type="button"
                            />
                            <PrimaryButton
                                className='btn btn-submit'
                                title={'save_sales_tax'}
                                loading={loading}
                                type="submit"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateSalesTax;